{
  "dateFormats": {
    "long": "MMMM d, yyyy",
    "short": "MM/dd/yyyy"
  },
  "card": {
    "badge": "Certificate",
    "code": "Code:",
    "issuedAt": "Issued on:",
    "completedAt": "Completed on:",
    "completed": "Completed",
    "view": "View",
    "downloading": "Downloading...",
    "download": "Download"
  },
  "viewer": {
    "title": "Certificate of Completion",
    "description": "Certificate preview",
    "student": "Student",
    "code": "Code",
    "issueDate": "Issue date",
    "status": "Status",
    "valid": "Valid",
    "loading": "Loading certificate...",
    "previewTitle": "Certificate preview",
    "validNotice": "Valid certificate, verifiable with the code above",
    "openNewTab": "Open in new tab",
    "downloading": "Downloading...",
    "downloadPdf": "Download PDF"
  },
  "generator": {
    "title": "CERTIFICATE OF COMPLETION",
    "subtitle": "Xtreed - Learning Platform",
    "certifyThat": "This certifies that",
    "completedCourse": "has successfully completed the course",
    "dedication": "demonstrating knowledge and dedication to their studies",
    "completionDate": "Completion date",
    "verificationCode": "Verification code",
    "generatingCode": "Generating...",
    "platform": "Platform",
    "validNotice": "This certificate is valid and can be verified with the code above.",
    "copyright": "© {{year}} Xtreed. All rights reserved.",
    "generating": "Generating certificate...",
    "generate": "Generate certificate",
    "generated": "Certificate generated",
    "downloading": "Downloading...",
    "downloadPdf": "Download PDF"
  },
  "service": {
    "qrCodeError": "Failed to generate QR code",
    "linkedInCopy": {
      "module": {
        "title": "🎓 Module Completed: {{title}}",
        "description": "I just completed the \"{{title}}\" module on Xtreed! One more step in my professional development journey. 💻✨",
        "hashtags": "#Xtreed #Programming #Development #Learning #TechEducation"
      },
      "course": {
        "title": "🏆 Course Completed: {{title}}",
        "description": "Certificate earned! I successfully completed the \"{{title}}\" course on Xtreed. New knowledge gained and ready for new challenges! 🚀",
        "hashtags": "#Xtreed #ProfessionalCertificate #Programming #TechSkills #TechCareer"
      },
      "track": {
        "title": "🎯 Track Completed: {{title}}",
        "description": "Mission accomplished! I finished the entire \"{{title}}\" track on Xtreed. A complete journey of learning and professional growth! 🌟",
        "hashtags": "#Xtreed #TrackCompleted #FullStack #ProfessionalDeveloper #TechCareer"
      }
    }
  },
  "blockchainVerifier": {
    "toasts": {
      "enterHash": "Enter the transaction hash",
      "verifiedTitle": "Certificate verified on the blockchain!",
      "verifiedDescription": "Authentic and immutable document",
      "notFoundTitle": "Hash not found on the blockchain",
      "notFoundDescription": "Check that the hash is correct",
      "verifiedDemo": "Certificate verified on the blockchain! (DEMO)",
      "hashCopied": "Hash copied!"
    },
    "networkStats": {
      "status": {
        "online": "online",
        "delayed": "delayed",
        "offline": "offline"
      },
      "certificates": "Certificates",
      "transactions": "Transactions",
      "lastBlock": "Latest Block",
      "averageGas": "Average Gas"
    },
    "header": {
      "title": "Blockchain Verification",
      "description": "Verify the authenticity of Xtreed certificates on the blockchain. Immutable records guarantee maximum security and reliability."
    },
    "form": {
      "title": "Verify Transaction Hash",
      "description": "Enter the blockchain transaction hash to verify a certificate",
      "hashLabel": "Transaction Hash",
      "supported": "Supported: Ethereum and Polygon • Real-time verification"
    },
    "result": {
      "validTitle": "Certificate Verified on the Blockchain ✓",
      "invalidTitle": "Hash Not Found ✗",
      "validDescription": "Record found on the blockchain - authentic and immutable document",
      "invalidDescription": "This hash could not be found on the blockchain",
      "verifiedAt": "Verified on {{date}}",
      "block": "Block #{{block}}",
      "confirmations_one": "{{count}} confirmation",
      "confirmations_zero": "{{count}} confirmations",
      "confirmations_other": "{{count}} confirmations",
      "explorer": "Explorer",
      "copy": "Copy"
    },
    "details": {
      "title": "Verified Certificate Details",
      "certificateInfo": "Certificate Information",
      "certificateId": "Certificate ID",
      "student": "Student",
      "course": "Course/Content",
      "issueDate": "Issue Date",
      "blockchainData": "Blockchain Data",
      "transactionHash": "Transaction Hash",
      "certificateHash": "Certificate Hash",
      "block": "Block",
      "timestamp": "Timestamp"
    },
    "advanced": {
      "show": "Show Technical Information",
      "hide": "Hide Technical Information",
      "network": "Network",
      "gasUsed": "Gas Used",
      "confirmations": "Confirmations",
      "about": "<bold>About Blockchain Verification:</bold> This certificate was immutably recorded on the {{network}} blockchain. The unique hash guarantees that the document cannot be forged or altered after issuance."
    },
    "newVerification": "New Verification",
    "howItWorks": {
      "title": "How blockchain verification works",
      "item1": "Every Xtreed certificate is recorded on the blockchain with a unique hash",
      "item2": "The record is immutable and permanent - it cannot be altered or forged",
      "item3": "Verification is instant and works 24/7 anywhere in the world",
      "item4": "We support both Ethereum and Polygon for maximum compatibility"
    },
    "formats": {
      "dateTime": "MM/dd/yyyy h:mm a",
      "shortDateTime": "MM/dd h:mm a",
      "longDate": "MMMM d, yyyy"
    }
  },
  "gallery": {
    "toasts": {
      "loadError": "Error loading certificates",
      "downloadStarted": "Download started!",
      "downloadError": "Error downloading certificate",
      "sharedOnLinkedIn": "Shared on LinkedIn!",
      "linkCopied": "Link copied to clipboard!",
      "shareError": "Error sharing certificate"
    },
    "fileName": "certificate-{{id}}.pdf",
    "stats": {
      "total": "Total Certificates",
      "modules": "Modules Completed",
      "courses": "Courses Completed",
      "tracks": "Tracks Completed"
    },
    "types": {
      "module": "Module",
      "course": "Course",
      "track": "Track"
    },
    "badges": {
      "physical": "Physical"
    },
    "menu": {
      "view": "View",
      "download": "Download",
      "share": "Share"
    },
    "issuedOn": "Issued on {{date}}",
    "metrics": {
      "views": "Views",
      "downloads": "Downloads",
      "shares": "Shares"
    },
    "actions": {
      "view": "View",
      "download": "Download"
    },
    "title": "My Certificates",
    "found_one": "{{count}} certificate found",
    "found_zero": "{{count}} certificates found",
    "found_other": "{{count}} certificates found",
    "searchPlaceholder": "Search certificates...",
    "filters": {
      "all": "All",
      "module": "Modules",
      "course": "Courses",
      "track": "Tracks"
    },
    "sort": {
      "newest": "Newest",
      "oldest": "Oldest",
      "name": "Name",
      "type": "Type"
    },
    "selected_one": "{{count}} certificate selected",
    "selected_zero": "{{count}} certificates selected",
    "selected_other": "{{count}} certificates selected",
    "batch": {
      "download": "Batch Download",
      "share": "Share"
    },
    "loading": "Loading certificates...",
    "empty": {
      "noResultsTitle": "No certificates found",
      "noCertificatesTitle": "You don't have any certificates yet",
      "noResultsDescription": "Try adjusting your search filters",
      "noCertificatesDescription": "Complete courses and modules to earn your professional certificates",
      "exploreCourses": "Explore Courses"
    },
    "formats": {
      "date": "MM/dd/yyyy"
    }
  },
  "generatorV3": {
    "typeTitles": {
      "module": "MODULE CERTIFICATE",
      "course": "CERTIFICATE OF COMPLETION",
      "track": "TRACK CERTIFICATE",
      "default": "PROFESSIONAL CERTIFICATE"
    },
    "toasts": {
      "generatedTitle": "Certificate generated successfully!",
      "generatedSharedOnLinkedIn": "It was also shared on your LinkedIn!",
      "generatedReady": "Certificate ready for download.",
      "viewAction": "View",
      "internalServerError": "Internal server error",
      "generateError": "Error generating certificate",
      "downloadStarted": "Download started!",
      "downloadError": "Error downloading certificate",
      "alreadyShared": "Certificate has already been shared automatically!"
    },
    "fileName": "certificate-{{id}}.pdf",
    "completedOn": "Completed on {{date}}",
    "tagline": "Xtreed - Professional Development Platform",
    "body": {
      "certifyThat": "This is to certify that",
      "completedModule": "has successfully completed the module",
      "completedTrack": "has completed the entire track",
      "completedCourse": "has successfully completed the course",
      "demonstrating": "demonstrating knowledge and dedication to their studies"
    },
    "options": {
      "title": "Advanced Options",
      "qrCode": "Verification QR Code",
      "blockchain": "Blockchain Record",
      "linkedin": "Share on LinkedIn",
      "physicalDelivery": "Physical Delivery"
    },
    "details": {
      "completionDate": "Completion Date",
      "verificationCode": "Verification Code",
      "willBeGenerated": "Will be generated...",
      "onlineVerification": "Online Verification",
      "available247": "Available 24/7"
    },
    "footer": {
      "validity": "This certificate is valid and can be verified through its unique QR code and code.",
      "blockchain": "Blockchain registration guarantees the authenticity and integrity of the document.",
      "copyright": "© {{year}} Xtreed. All rights reserved."
    },
    "actions": {
      "generating": "Generating Certificate...",
      "generate": "Generate Professional Certificate",
      "success": "Certificate Generated Successfully!",
      "downloadPdf": "Download PDF",
      "verify": "Verify"
    },
    "formats": {
      "date": "MM/dd/yyyy",
      "longDate": "MMMM d, yyyy"
    }
  },
  "verificationV3": {
    "toasts": {
      "enterCode": "Enter the verification code",
      "successTitle": "Certificate verified successfully!",
      "successDescription": "Authentic and valid document",
      "invalidTitle": "Invalid certificate",
      "error": "Verification error",
      "linkCopied": "Link copied!"
    },
    "unableToVerify": "Unable to verify authenticity",
    "header": {
      "title": "Certificate Verification",
      "description": "Enter the certificate verification code to validate its authenticity. All Xtreed certificates are protected with blockchain and a digital signature."
    },
    "form": {
      "title": "Verify Certificate",
      "codeLabel": "Verification Code",
      "placeholder": "E.g. DCF-2024-ABCD-1234",
      "availability": "Verification available 24/7 • Blockchain technology"
    },
    "result": {
      "validTitle": "Valid Certificate ✓",
      "invalidTitle": "Invalid Certificate ✗",
      "validDescription": "Authentic and verified document",
      "verifiedAt": "Verified on {{date}}",
      "details": "Details"
    },
    "info": {
      "title": "Certificate Information",
      "student": "Student",
      "course": "Course/Content",
      "issueDate": "Issue Date",
      "type": "Certificate Type",
      "types": {
        "module": "Module",
        "course": "Course",
        "track": "Track"
      },
      "status": "Status: <active>Active</active>",
      "share": "Share"
    },
    "advanced": {
      "title": "Advanced Security Checks",
      "checks": {
        "qrCode": "Valid QR Code",
        "digitalSignature": "Digital Signature",
        "blockchain": "Blockchain Verified",
        "template": "Valid Template",
        "notRevoked": "Not Revoked",
        "withinValidity": "Within Validity Period"
      },
      "maxSecurityTitle": "Maximum Security:",
      "maxSecurityDescription": "This certificate uses multiple layers of security, including blockchain, cryptographic digital signature and real-time verification."
    },
    "warnings": "Warnings",
    "verifyAnother": "Verify Another Certificate",
    "formats": {
      "dateTime": "MM/dd/yyyy h:mm a",
      "longDate": "MMMM d, yyyy"
    }
  },
  "viewerV3": {
    "fileName": "certificate-{{id}}",
    "dialogDescription": "Certificate view",
    "formats": {
      "date": "MM/dd/yyyy",
      "dateTime": "MM/dd/yyyy h:mm a"
    },
    "toasts": {
      "downloadStarted": "Download started!",
      "downloadStartedDescription": "High-quality PDF certificate",
      "downloadError": "Error downloading certificate",
      "linkedInShared": "Shared on LinkedIn!",
      "linkedInSharedDescription": "Certificate added to your profile",
      "viewPost": "View post",
      "linkedInShareError": "Error sharing on LinkedIn",
      "screenshotSaved": "Screenshot saved!",
      "screenshotError": "Error capturing screenshot",
      "linkCopied": "Link copied!",
      "linkCopiedDescription": "Verification link copied to clipboard",
      "comingSoon": "Coming soon!",
      "physicalDeliveryComingSoon": "Physical delivery will be available soon"
    },
    "info": {
      "student": "Student",
      "code": "Code",
      "issueDate": "Issue date",
      "status": "Status"
    },
    "status": {
      "valid": "Valid",
      "revoked": "Revoked",
      "pending": "Pending"
    },
    "metrics": {
      "views": "Views",
      "downloads": "Downloads",
      "verifications": "Verifications",
      "shares": "Shares"
    },
    "title": {
      "module": "Module Certificate",
      "track": "Track Certificate",
      "course": "Certificate of Completion"
    },
    "tabs": {
      "preview": "Preview",
      "details": "Details",
      "sharing": "Share",
      "verification": "Verification"
    },
    "preview": {
      "loading": "Loading certificate...",
      "iframeTitle": "Certificate preview"
    },
    "details": {
      "contentInfo": "Content information",
      "title": "Title",
      "description": "Description",
      "workload": "Workload",
      "hours": "{{hours}}h",
      "skills": "Certified skills",
      "security": "Security and verification",
      "validSignature": "Valid digital signature",
      "signedBy": "Signed by {{issuer}} on {{date}}",
      "blockchainRegistered": "Registered on the blockchain",
      "hash": "Hash: {{hash}}...",
      "viewOnBlockchain": "View on blockchain →"
    },
    "qrCode": {
      "title": "Verification QR code",
      "scanToVerify": "Scan to verify authenticity"
    },
    "physicalDelivery": {
      "requested": "Physical delivery requested",
      "status": "Status:",
      "delivered": "Delivered",
      "shipped": "Shipped",
      "processing": "Processing",
      "trackingCode": "Tracking code:",
      "requestProcessing": "Request being processed..."
    },
    "sharing": {
      "social": "Social sharing",
      "shareOnLinkedIn": "Share on LinkedIn",
      "copyVerificationLink": "Copy verification link",
      "saveAsImage": "Save as image",
      "sharedOnLinkedIn": "Shared on LinkedIn",
      "sharedAt": "On {{date}}",
      "copyLink": "Copy link"
    },
    "verification": {
      "title": "Authenticity verification",
      "publicLink": "Public verification link",
      "copy": "Copy",
      "open": "Open",
      "code": "Verification code",
      "codeHint": "Use this code in the verification form",
      "howTo": "<bold>How to verify:</bold> Anyone can verify the authenticity of this certificate using the code or link above. Verification includes blockchain, digital signature and integrity checks."
    },
    "footer": {
      "validId": "Valid and verifiable certificate • ID: {{id}}...",
      "openInNewTab": "Open in new tab",
      "downloadPdf": "Download PDF",
      "requestPhysical": "Request printed copy"
    }
  },
  "linkedIn": {
    "defaults": {
      "headline": "Xtreed Student",
      "module": {
        "title": "🎓 Module Completed: {title}",
        "description": "I just completed the \"{title}\" module on Xtreed! One more step in my professional development journey. 💻✨",
        "hashtags": "#Xtreed, #Learning, #Knowledge, #Certificate"
      },
      "course": {
        "title": "🏆 Course Completed: {title}",
        "description": "Certificate earned! I successfully completed the \"{title}\" course on Xtreed. New knowledge gained and ready for new challenges! 🚀",
        "hashtags": "#Xtreed, #ProfessionalCertificate, #Learning, #Career"
      },
      "track": {
        "title": "🎯 Track Completed: {title}",
        "description": "Mission accomplished! I finished the entire \"{title}\" track on Xtreed. A complete journey of learning and professional growth! 🌟",
        "hashtags": "#Xtreed, #TrackCompleted, #Training, #Career"
      }
    },
    "toasts": {
      "comingSoon": "Coming soon!",
      "comingSoonDescription": "LinkedIn integration will be available soon",
      "connected": "Connected to LinkedIn!",
      "connectError": "Error connecting to LinkedIn",
      "disconnected": "Disconnected from LinkedIn",
      "disconnectError": "Error disconnecting",
      "saved": "Settings saved!",
      "saveError": "Error saving settings"
    },
    "templateEditor": {
      "postTitle": "Post title",
      "postTitlePlaceholder": "E.g. 🎓 Module Completed: {title}",
      "titleHint": "Use {title} to insert the certificate name automatically",
      "description": "Description",
      "descriptionPlaceholder": "Describe your achievement...",
      "hashtags": "Hashtags",
      "hashtagsPlaceholder": "#Xtreed, #Learning, #Certificate",
      "hashtagsHint": "Separate hashtags with commas"
    },
    "post": {
      "now": "Now",
      "professionalCertificate": "PROFESSIONAL CERTIFICATE",
      "like": "👍 Like",
      "comment": "💬 Comment",
      "repost": "🔄 Repost",
      "send": "📤 Send"
    },
    "header": {
      "title": "LinkedIn Integration",
      "subtitle": "Set up automatic sharing of your certificates on LinkedIn. Add credibility to your professional profile and celebrate your achievements!"
    },
    "connection": {
      "connectedTitle": "LinkedIn Connected",
      "connectTitle": "Connect to LinkedIn",
      "connectedAs": "Connected as {{name}}",
      "connectDescription": "Connect your account to share certificates automatically",
      "viewProfile": "View profile",
      "disconnect": "Disconnect",
      "connect": "Connect LinkedIn"
    },
    "profile": {
      "name": "Name:",
      "headline": "Headline:",
      "publicProfile": "Public profile:"
    },
    "tabs": {
      "settings": "Settings",
      "templates": "Templates",
      "preview": "Preview"
    },
    "settings": {
      "title": "Sharing settings",
      "enable": "Enable integration",
      "enableDescription": "Allows Xtreed to post on your LinkedIn",
      "autoShare": "Automatic sharing",
      "autoShareDescription": "Posts automatically when you receive a certificate",
      "postSettings": "Post settings",
      "includeImage": "Include certificate image",
      "includeImageDescription": "Attaches a visual preview",
      "includeDescription": "Include detailed description",
      "includeDescriptionDescription": "Adds descriptive text",
      "addToEducation": "Add to Education section",
      "addToEducationDescription": "Appears on the timeline",
      "addToCertifications": "Add to Certifications",
      "addToCertificationsDescription": "Licenses & certifications section",
      "visibility": "Post visibility",
      "public": "Public",
      "connections": "Connections",
      "private": "Private"
    },
    "templates": {
      "modules": "Modules",
      "tracks": "Tracks",
      "courses": "Courses",
      "hidePreview": "Hide preview",
      "showPreview": "Show preview"
    },
    "preview": {
      "sampleTitle": "Complete React.js - From Beginner to Advanced",
      "title": "Post preview",
      "description": "See how your certificates will appear on LinkedIn",
      "testTitle": "Certificate title (for testing)",
      "testTitlePlaceholder": "Course or module name",
      "module": "Module",
      "course": "Course",
      "track": "Track"
    },
    "permissions": {
      "title": "About permissions",
      "description": "Xtreed uses LinkedIn's official API with limited, secure permissions. We will never post without your prior authorization, and you can disconnect at any time."
    },
    "unsaved": {
      "title": "Unsaved changes",
      "description": "Your settings have been modified",
      "save": "Save"
    }
  },
  "physicalDelivery": {
    "formats": {
      "date": "MM/dd/yyyy",
      "dateTime": "MM/dd/yyyy h:mm a"
    },
    "zipCodeLine": "ZIP: {{zipCode}}",
    "shipping": {
      "standard": {
        "name": "Standard",
        "description": "Economy delivery via Correios"
      },
      "express": {
        "name": "Express",
        "description": "Fast delivery with SEDEX"
      },
      "premium": {
        "name": "Premium",
        "description": "Special delivery with deluxe packaging"
      },
      "features": {
        "premiumPaper": "Certificate on premium paper",
        "protectiveEnvelope": "Protective envelope",
        "basicTracking": "Basic tracking",
        "fullTracking": "Full tracking",
        "insuranceIncluded": "Insurance included",
        "specialPaper": "Certificate on special 300gsm paper",
        "premiumBox": "Xtreed premium box",
        "customEnvelope": "Custom envelope",
        "authenticitySeal": "Seal of authenticity",
        "realTimeTracking": "Real-time tracking",
        "fullInsurance": "Full insurance",
        "signatureDelivery": "Signature on delivery"
      },
      "businessDays_one": "{{count}} business day",
      "businessDays_zero": "{{count}} business days",
      "businessDays_other": "{{count}} business days",
      "title": "Choose a shipping method",
      "summary": "Shipping summary",
      "method": "Method:",
      "cost": "Cost:",
      "deadline": "Delivery time:"
    },
    "toasts": {
      "loadError": "Error loading delivery information",
      "requiredFields": "Fill in all required fields",
      "requested": "Physical delivery requested!",
      "estimatedDelivery": "Estimated delivery: {{date}}",
      "requestError": "Error requesting physical delivery",
      "codeCopied": "Code copied!"
    },
    "progress": {
      "pending": "Requested",
      "processing": "Processing",
      "shipped": "Shipped",
      "delivered": "Delivered"
    },
    "tracking": {
      "title": "Delivery tracking - {{title}}",
      "loading": "Loading information...",
      "orderInfo": "Order information",
      "certificate": "Certificate:",
      "status": "Status:",
      "delivered": "Delivered",
      "shipped": "Shipped",
      "processing": "Processing",
      "requestedAt": "Requested on:",
      "deliveryAddress": "Delivery address",
      "trackingCode": "Tracking code",
      "copy": "Copy",
      "track": "Track",
      "latestUpdates": "Latest updates",
      "refresh": "Refresh status"
    },
    "header": {
      "title": "Printed certificate delivery",
      "subtitle": "Get your printed certificate delivered to your home in professional quality. Premium paper, special packaging and tracked delivery anywhere in Brazil."
    },
    "form": {
      "title": "Delivery details",
      "personalInfo": "Personal information",
      "fullName": "Full name *",
      "fullNamePlaceholder": "Name as it should appear on the delivery",
      "phone": "Phone *",
      "email": "Email *",
      "emailPlaceholder": "you@email.com",
      "address": "Delivery address",
      "zipCode": "ZIP code *",
      "street": "Street/Avenue *",
      "streetPlaceholder": "Street name",
      "number": "Number *",
      "complement": "Apartment, suite, etc.",
      "complementPlaceholder": "Apt 45",
      "neighborhood": "Neighborhood *",
      "neighborhoodPlaceholder": "Neighborhood name",
      "city": "City *",
      "cityPlaceholder": "Your city",
      "state": "State *",
      "statePlaceholder": "State",
      "country": "Country",
      "countryValue": "Brazil",
      "specialInstructions": "Special instructions",
      "specialInstructionsPlaceholder": "Notes for the courier (optional)"
    },
    "actions": {
      "continue": "Continue",
      "back": "Back"
    },
    "confirmation": {
      "title": "Order confirmation",
      "certificateToSend": "Certificate to be shipped",
      "titleLabel": "Title:",
      "idLabel": "ID:",
      "issuedAt": "Issued on:",
      "deliveryData": "Delivery details",
      "name": "Name:",
      "phone": "Phone:",
      "email": "Email:",
      "address": "Address:",
      "financialSummary": "Cost summary",
      "certificate": "Certificate:",
      "free": "Free",
      "shipping": "Shipping ({{method}}):",
      "total": "Total:",
      "paymentInfo": "<bold>About payment:</bold> The shipping fee will only be charged at the time of shipment. You will receive a payment link when the certificate is ready to ship.",
      "confirm": "Confirm order"
    }
  },
  "templateEditor": {
    "title": {
      "create": "Create Template",
      "edit": "Edit Template",
      "view": "View Template"
    },
    "dialogDescription": "Configure the certificate template",
    "unsaved": "Unsaved",
    "actions": {
      "edit": "Edit",
      "preview": "Preview",
      "save": "Save"
    },
    "toasts": {
      "nameRequired": "Name and display name are required",
      "created": "Template created!",
      "updated": "Template updated!",
      "saveError": "Error saving template"
    },
    "tabs": {
      "general": "General",
      "design": "Design",
      "elements": "Elements",
      "advanced": "Advanced"
    },
    "general": {
      "title": "Basic Information",
      "nameLabel": "Template Name *",
      "namePlaceholder": "Internal name",
      "displayNameLabel": "Display Name *",
      "displayNamePlaceholder": "Name visible to users",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Template description",
      "typeLabel": "Certificate Type",
      "types": {
        "module": "Module",
        "course": "Course",
        "track": "Track"
      },
      "designVariantLabel": "Design Variant"
    },
    "designVariants": {
      "minimal": {
        "label": "Minimalist",
        "description": "Clean and modern design"
      },
      "classic": {
        "label": "Classic",
        "description": "Traditional and elegant style"
      },
      "modern": {
        "label": "Modern",
        "description": "Contemporary look"
      },
      "premium": {
        "label": "Premium",
        "description": "Luxurious design with finishes"
      },
      "elite": {
        "label": "Elite",
        "description": "Highest level of sophistication"
      }
    },
    "design": {
      "colorsTitle": "Template Colors",
      "colorKeys": {
        "primary": "primary",
        "secondary": "secondary",
        "accent": "accent",
        "text": "text",
        "background": "background"
      },
      "presetColors": "Preset Colors",
      "typographyTitle": "Typography",
      "fontKeys": {
        "primary": "primary",
        "secondary": "secondary",
        "accent": "accent"
      }
    },
    "elements": {
      "title": "Template Elements",
      "add": "Add",
      "addDialogTitle": "Add Element",
      "addDialogDescription": "Select an element type to add to the template",
      "emptyTitle": "No elements added yet",
      "emptyDescription": "Click \"Add\" to get started"
    },
    "elementTypes": {
      "text": {
        "label": "Text",
        "description": "Add dynamic text"
      },
      "image": {
        "label": "Image",
        "description": "Insert a logo or image"
      },
      "background": {
        "label": "Background",
        "description": "Background color or gradient"
      },
      "border": {
        "label": "Border",
        "description": "Decorative frames"
      },
      "qrCode": {
        "label": "QR Code",
        "description": "Verification code"
      },
      "signature": {
        "label": "Signature",
        "description": "Digital signature"
      }
    },
    "element": {
      "name": "Name",
      "zIndex": "Z-Index",
      "x": "X (mm)",
      "y": "Y (mm)",
      "width": "Width",
      "height": "Height",
      "content": "Content",
      "variable": "Variable",
      "fontSize": "Font Size",
      "color": "Color",
      "imageUrl": "Image URL"
    },
    "advanced": {
      "printSpecsTitle": "Print Specifications",
      "dpi": "DPI",
      "colorMode": "Color Mode"
    },
    "preview": {
      "title": "Preview",
      "simplified": "Simplified preview",
      "dimensions": "Dimensions: {{width}}x{{height}}mm",
      "elementsCount_one": "Elements: {{count}}",
      "elementsCount_zero": "Elements: {{count}}",
      "elementsCount_other": "Elements: {{count}}"
    }
  }
}
